import {createContext} from 'react';

export const RatePlansListContext = createContext({});
